import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Box, Container, Grid, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import "../../css/InicioPage/Productos.css"
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";



export const ServiciosdosInicio = () => {
  const [loading, setLoading] = useState(false);
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [servicios, setServicios] = useState([]);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const fetchSliders = useCallback(async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${backendURL}/api/all/public/servicio/home`);
      setServicios(response.data.data);
      setLoading(false)
    } catch (error) {
      console.error("Error al obtener sliders:", error);
    }
  }, [backendURL]);

  // Llamada inicial a sliders cuando hay token
  useEffect(() => {

    fetchSliders();

  }, [fetchSliders]);



  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress size={80} thickness={6} />
        </Box>
      </div>
    );
  }

  return (
    <section style={{ textAlign: "center" }}>
      <Container maxWidth="lg" sx={{ pt: 10, pb: 20 }}>
        <div className="TituloPorductosHome">
          <h2 className="parte1" >Nuestros </h2>

          <h2 className="parte2"> servicios</h2>
        </div>

        <Grid container spacing={7} ref={ref} sx={{
          marginTop: '100px', '@media (max-width:600px)': {
            marginTop: '40px',
          },
        }}>
          {servicios.map((servicio, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <Box sx={{
                  display: 'flex',
                  alignItems: ' center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  marginBottom: '50px'



                }}>
                  <Box
                    sx={{
                      width: '100%',

                    }}
                  >
                    <Box sx={{
                      width: '100%',
                      height: '75px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      textAlign: 'center'
                    }}>
                      <h2 className="tituloserviciohome">{servicio.titulo}</h2>
                      {servicio.titulo1 && (
                        <h2 className="tituloserviciohome">{servicio.titulo1}</h2>
                      )}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      height: '5px', // grosor de la línea
                      width: '100px',
                      backgroundColor: servicio.color || '#ccc',
                      my: 2, // margen vertical (arriba y abajo)
                      marginBottom: '50px',
                      borderRadius: '4px'
                    }}
                  />
                  <Box className="ImagenProductoHome">
                    {servicio.icono && (
                      <img
                        src={`${backendURL}/${servicio.icono}`}
                        alt="HOD | Maquinas Dispensadoras"
                        title="HOD | Maquinas Dispensadoras"
                      />
                    )}
                  </Box>
                </Box>


              </motion.div>
            </Grid>
          ))}

          <Grid size={12}>
            <div className="BotonProductoHome">
              <Link to='/servicio' style={{ textDecoration: 'none', color: 'inherit' }}>
                <button>
                  ver más
                  <span className="flecha-hover"><FaArrowRight /></span>
                </button>
              </Link>
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};